import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import useQueryParams from 'hooks/UseQueryParams';
import React, { useEffect, useImperativeHandle } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { renderQuestionsRecursively } from 'sharedComponents/commonHelper/questionRenderer';
import { StepperFromProps } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';
import { getToken, postBlackBookAnswers } from 'store/CommonModuleState';
import { RootState } from 'store/store';
import { BLACK_BOOK_QUESTIONS_V2, transformSingleChoiceData, VEHICLE_CONDITIONS_PAGE_2 } from '../TradeInConstant';
import { transformQuestions } from '../TradeInUtils';
import Logger from 'utils/logger';

const VehicleConditions: React.ForwardRefRenderFunction<unknown, StepperFromProps> = ({ onNext, onBack }, ref) => {
  const { t } = useTranslation();
  const dispatch: ThunkDispatch<RootState, AnyAction, AnyAction> = useDispatch();

  const queryParams = useQueryParams();
  const uvc = queryParams.get('uvc');

  const { token } = useSelector((state: RootState) => state.commonModuleStore);
  const { vehicleOptions } = useSelector((state: RootState) => state.tradeInStore);

  const { authenticateClientData } = useSelector((state: RootState) => state.auth) || {};

  const version = queryParams.get('version');
  const type = queryParams.get('type');

  const hasCalledNextStep = React.useRef(false);
  const hasRendered = React.useRef(false);

  const { control, trigger, watch, getValues } = useFormContext();

  const watchAllFields = watch();

  useEffect(() => {
    if (hasRendered.current) return;
    hasRendered.current = true;

    // dispatch(
    //   getBlackBookQuestions({
    //     customerId: 'test',
    //     token,
    //   })
    // ).then((questionResp) => {
    //   console.log('res', questionResp);

    //   if (!(questionResp?.payload?.questions?.length > 0)) {
    //     dispatch(getToken('test')).then((res: any) => {
    //       console.log('res', res);
    //       if (res?.payload?.token) {
    //         dispatch(
    //           getBlackBookQuestions({
    //             customerId: 'test',
    //             token: res?.payload?.token,
    //           })
    //         );
    //       }
    //     });
    //   }
    // });
  }, [token, dispatch]);

  const nextStep = () => {
    if (hasCalledNextStep.current) return;
    hasCalledNextStep.current = true;

    if (version === '1.0' || version === '1.1' || version === '1.2' || version === '1.3') {
      const singleChoice = transformSingleChoiceData(transformQuestions(BLACK_BOOK_QUESTIONS_V2()), getValues(), t);

      const dealershipId =
        authenticateClientData?.data?.widgetData?.dealershipId ||
        authenticateClientData?.data?.widgetData?.dealershipName;

      const requestData = {
        postData: {
          vin: '',
          uvc: uvc || getValues('vehicleSearch')?.uvc,
          mileage: getValues('mileage'),
          state: getValues('province'),
          answers: singleChoice?.map(({ actualAnswer, actualAnswerTxt, ...rest }) => rest),
        },

        visitor: 'testVisitor',
        customerId: dealershipId,
        token,
      };

      dispatch(postBlackBookAnswers(requestData)).then((res) => {
        Logger.custom('trade_value', {
          uvc: uvc || getValues('vehicleSearch')?.uvc,
          mileage: getValues('mileage'),
          offer: res?.payload?.message?.Value || 'N/A',
          client: authenticateClientData?.data?.client || '',
          widgetName: authenticateClientData?.data?.widgetName || '',
          module: 'Trade-In',
        });
        if (res?.payload == undefined) {
          dispatch(getToken(dealershipId)).then((res: any) => {
            if (res?.payload?.message?.token) {
              const updatedRequestData = { ...requestData, token: res?.payload?.message?.token };

              dispatch(postBlackBookAnswers(updatedRequestData)).then(() => {
                onNext?.();
              });
            } else {
              onNext?.();
            }
          });
        } else {
          onNext?.();
        }
      });
    }
  };

  const backStep = () => {
    onBack?.(vehicleOptions?.length > 0 ? (type === 'banner' ? 1 : 2) : type === 'banner' ? 0 : 1);
  };

  useImperativeHandle(ref, () => ({
    nextStep,
    backStep,
  }));

  return (
    <div className='tradein-v3__body'>
      <h4 className='tradein-v3__body__title text-primary'>{`${t('stepperFormTradeIn.vehicleConditions')}`}</h4>
      <p>{t('stepperFormTradeIn.vehicleConditionsDesc')}</p>
      {renderQuestionsRecursively({
        questions: transformQuestions(BLACK_BOOK_QUESTIONS_V2()),
        // questions: transformQuestions(blackBookQuestions?.questions),
        control,
        trigger,
        watchAllFields,
        t,
        watch,
      })}

      {renderQuestionsRecursively({
        questions: VEHICLE_CONDITIONS_PAGE_2(t),
        control,
        trigger,
        watchAllFields,
        t,
        watch,
      })}
    </div>
  );
};

const VehicleConditionsStep = React.forwardRef(VehicleConditions);

export default VehicleConditionsStep;
